import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectCheckListJoiningOrSignoffCrewVisa {
  Approved = 0,
  Rejected = 1,
  Cancelled = 2,
  Blacklisted = 3,
  AWTDocs = 4,
  SNTToProc = 5,
  UProcess = 6,
}

export const projectCheckListJoiningOrSignoffCrewVisaOptions = mapEnumToOptions(ProjectCheckListJoiningOrSignoffCrewVisa);
